<template>
    <div class="weekly-section-heading">
        <div>
            <h3 class="heading">FACT CHECK SPOTLIGHT</h3>
            <h2 class="title" v-html="title"></h2>
            <div>
                <template v-if="articleImage">
                    <img :src="articleImage" alt="" height="271" width="429" border="0">
                </template>
                <section v-html="exerpt"></section>
            </div>
            <template v-if="hasArticles">
                <div class="archive_button">
                    <a :href="link">Read More →</a>
                </div>
            </template>
        </div>
        <div v-for="(article, index) in articles" :key="index">
            <h3><a :href="article.url + article.permalink" v-html="article.title"></a></h3>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "roundup-article",
    data() {
        return {
            articles: [],
            title: "",
            articleImage: "",
            exerpt: "",
            link: "",
            hasArticles: false
        };
    },
    created() {
        this.allArticles();
    },
    methods: {
        ImgStrip(){
            var html = this.exerpt;
            var re = /<img[^>]+src="([^">]+)/g;
            var results = re.exec(html);

            if(results){
                return results[1];
            }
        },
        getMainArticle: function (articles) {
            if(this.articles.length != 0){
                this.hasArticles = true;
                this.title = articles[0]["title"];
                this.exerpt = articles[0]["body_text"];
                this.link = articles[0]["url"] + this.articles[0]["permalink"];

                this.articleImage = this.ImgStrip();

                this.exerpt = this.exerpt.substring(0, 700) + ' . . .';

                this.articles.shift();
            }
        },
        allArticles(){
            jsonp("https://www.realclearpolitics.com/fact_check_review/fact_check_spotlight/json/live/factcheck_spotlight.jsonp", {name: 'jsonFackCheckSpotlight'}, (err, data)=>{
                if(err){
                    console.log(err);
                } else {
                    this.articles = data;
                    this.getMainArticle(this.articles);
                }
            })
        }
    },
};
</script>

<style scoped>
    .heading {
        font-size: 1.5em;
        padding: 0.5em;
        margin: 1em 0 1em 0;
        border: 3px solid #d60000;
    }
    .title {
        color: #d60000;
    }
    .links {
        font-size: 2em;
    }
    img {
        float:left;
        padding-right: 1em;
    }

    @media screen and (max-width: 1080px) {
        img {
            float: none;
            width: 100%;
            height: auto;
            padding: 0;
        }
    }
</style>
